<template>
  <div id="modalCreateEditUser" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Usuário</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-6">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.nome.$errors.length }"
                  placeholder="Nome do Usuário"
                  v-model="v$.user.nome.$model"
                />
                <span
                  v-if="
                    v$.user.nome.required.$invalid &&
                    v$.user.nome.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  E-mail: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.email.$errors.length }"
                  placeholder="usuario@email.com.br"
                  v-model="v$.user.email.$model"
                />
                <span
                  v-if="
                    v$.user.email.required.$invalid &&
                    v$.user.email.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Tipo de Usuário: <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="v$.user.tipo.$model">
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="tipo in tipoOptions"
                    :key="tipo.value"
                    :value="tipo.value"
                  >
                    {{ tipo.text }}
                  </option>
                </select>
                <span class="text-muted">
                  Administradores podem gerenciar perfis e usuários
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Status: <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="v$.user.status.$model">
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="option in statusOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-sm-12">
                <label class="form-label">
                  Selecione os perfis de acesso deste usuário:
                  <span class="text-danger">*</span>
                </label>
                <div class="row">
                  <div
                    v-for="profile in profiles"
                    :key="profile.id"
                    class="col-sm-4"
                  >
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="profile.id"
                        :value="profile.id"
                        v-model="userProfiles"
                      />
                      <label class="form-check-label" :for="profile.id">
                        {{ profile.nome }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-dark"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'
import TipoUsuarioEnum from '@/enums/tipoUsuarioEnum'

export default {
  name: 'CreateEditUserModal',

  props: {
    userId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      user: {
        nome: '',
        email: '',
        tipo: TipoUsuarioEnum.NORMAL,
        status: 1,
      },
      userProfiles: [],
      tipoOptions: [
        { value: 3, text: 'Normal' },
        { value: 2, text: 'Administrador' },
      ],
      statusOptions: [
        { value: 1, text: 'Ativo' },
        { value: 0, text: 'Inativo' },
      ],
      profiles: [],
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.userId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getProfiles() {
      try {
        this.profiles = await this.$store.dispatch('getProfiles')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async getUser() {
      try {
        const { user, userProfiles } = await this.$store.dispatch(
          'getUser',
          this.userId,
        )

        this.user = user
        this.userProfiles = userProfiles.map((profile) => profile.perfilId)

        showModal('modalCreateEditUser')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        if (this.userProfiles.length === 0) {
          this.$root.$refs.notification.warning(
            'Selecione pelo menos um perfil.',
          )
          return
        }

        this.disableButton = true
        try {
          let response = null

          if (this.userId) {
            response = await this.$store.dispatch('updateUser', {
              id: this.userId,
              user: this.user,
              userProfiles: this.userProfiles,
            })
          } else {
            response = await this.$store.dispatch('createUser', {
              user: this.user,
              userProfiles: this.userProfiles,
            })
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      user: {
        nome: {
          required,
        },
        email: {
          required,
          email,
        },
        tipo: {
          required,
        },
        status: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getProfiles()
    if (this.userId) {
      this.getUser()
    } else {
      showModal('modalCreateEditUser')
    }
  },
}
</script>
